import { useState } from 'react'
import { BsArrowRight, BsArrowLeft } from "react-icons/bs";
import styles from "../styles/componentStyles/arrow.module.css"

const ArrowBtn = ({ isDark, isLeft, btnClickFunction, isSmall=false }) => {
    const [hover, setHover] = useState(false);
    return (
        <>
            {isLeft ?
                <button
                    className={`${styles.arrow_button} ${isSmall && styles.arrow_small___btn} ${styles.arrow_button___left} ${isDark ? styles.arrow_button___dark : styles.arrow_button___light} ${hover ? styles.arrow_was_hovered___left : undefined}`}
                    onMouseOut={() => setHover(true)}
                    onClick={btnClickFunction}
                >
                    <BsArrowLeft className={`${styles.arrow} ${isSmall && styles.arrow_small}`} />
                </button>
                :
                <button
                    className={`${styles.arrow_button} ${isSmall && styles.arrow_small___btn}  ${styles.arrow_button___right} ${isDark ? styles.arrow_button___dark : styles.arrow_button___light} ${hover ? styles.arrow_was_hovered___right : undefined}`}
                    onMouseOut={() => setHover(true)}
                    onClick={btnClickFunction}
                >
                    <BsArrowRight className={`${styles.arrow} ${isSmall && styles.arrow_small}`} />
                </button>
            }
        </>
    )
}

export default ArrowBtn